import { registerArtifactPayload } from '@/features/documentPreview/artifactPayloadStore'
import {
  B2B_COPILOT_PLAN_THOUGHT_DETAILS,
  B2B_COPILOT_PLAN_USER_PROMPT,
  buildB2bCopilotPlanArtifactPayload,
  buildB2bCopilotPlanFinalBlocks,
  buildB2bCopilotPlanZipArtifactPayload,
} from './b2bCopilotPlanDemoContent.js'



export const B2B_COPILOT_PLAN_DEMO_THREAD_ID = 'thread-demo-b2b-copilot-plan'

export const B2B_COPILOT_PLAN_DEMO_EXCHANGE_ID = 'exchange-demo-b2b-copilot-plan'

export const B2B_COPILOT_PLAN_DEMO_USER_MSG_ID = 'msg-demo-b2b-copilot-user'

export const B2B_COPILOT_PLAN_DEMO_ASSISTANT_MSG_ID = 'msg-demo-b2b-copilot-assistant'

export const B2B_COPILOT_PLAN_DEMO_ARTIFACT_ID = 'artifact-demo-b2b-copilot-plan'

export const B2B_COPILOT_PLAN_ZIP_ARTIFACT_ID = 'artifact-demo-b2b-copilot-plan-zip'

export const B2B_DEMO_CONTENT_VERSION = 10

export const DEMO_NOW = 1_748_601_600_000

/**
 * @returns {{ thread: { id: string, title: string, createdAt: number, updatedAt: number }, messages: object[] }}
 */
